class SearchForm extends HTMLElement {
  /**
   * Orden obligatorio en Farmex: filtros -tag primero, texto del cliente al final.
   * Así options[prefix]=last aplica al término buscado (documentación Shopify).
   */
  static buildStorefrontSearchQuery(rawTerm) {
    let term = (rawTerm || '')
      .trim()
      .replace(/-tag:delete/gi, '')
      .replace(/-tag:persistente/gi, '')
      .replace(/-tag:RM/gi, '')
      .trim();
    if (!term) return '';
    const excludedTags = '-tag:delete -tag:persistente';
    return `${excludedTags} ${term}`.trim();
  }

  static getSearchSubmitUrl(form, rawTerm) {
    const q = SearchForm.buildStorefrontSearchQuery(rawTerm);
    if (!q) return null;
    const u = new URL(form.action);
    u.search = '';
    u.searchParams.set('q', q);
    const prefixInput = form.querySelector('input[name="options[prefix]"]');
    if (prefixInput?.value) {
      u.searchParams.set('options[prefix]', prefixInput.value);
    }
    return u.toString();
  }

  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (!this.input) return;

    this.form = this.input.form;

    this.form.addEventListener('submit', this.onSubmit.bind(this));
    this.form.addEventListener('reset', this.onFormReset.bind(this));

    this.input.addEventListener('input', debounce(() => {
      this.onChange();
    }, 300));
  }

  onSubmit(event) {
    event.preventDefault();
    const url = SearchForm.getSearchSubmitUrl(this.form, this.input.value);
    if (!url) return;
    window.location.href = url;
  }

  toggleResetButton() {
    if (!this.resetButton) return;

    this.resetButton.classList.toggle(
      'hidden',
      this.input.value.length === 0
    );
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
